import $ from "jquery";

export function addRows(tableHandle, dataElements) {
    if (!dataElements?.length) {
        return false
    }
    dataElements?.forEach(element => {
        let id = element._id;
        tableHandle?.rows.add($(`#${id}`));
        console.log("Rows added")

    });
    tableHandle?.rows().order();
    tableHandle?.rows().draw();
    return true;
}

export function deleteRows(tableHandle, dataElements) {

    if (!tableHandle || !dataElements?.length) return;


    dataElements?.forEach(element => {
        let id = element._id;
        tableHandle?.row(`#${id}`)?.remove();
        console.log("Rows deleted")

    });

    tableHandle?.rows().invalidate().draw("page");
}

export function updateRow(tableHandle, id) {
    tableHandle.row($(`#${id}`).closest("tr")).invalidate().draw();
}